import {Divider, Menu, MenuCaption, MenuItem} from '@genestack/ui';
import React from 'react';
import {navigate as browserNavigate} from 'wouter/use-browser-location';

import {DocumentTypeLabel} from '../../../../../components/document-type-label';
import {useCopyLinkToThisPage} from '../../../../../hooks/copy-link/use-copy-link-to-this-page';
import {useUserEditingPermissions} from '../../../../../hooks/user/use-has-permission';
import {isReadOnlyOntology} from '../../../../../utils/ontology';
import {CommitData} from '../../../../../providers/version';
import {useToggleFavoriteMutation} from '../../hooks/requests/toggle-favorite-mutation';
import {Link} from 'wouter';

interface Props {
    docInfo: ViewModeDoc;
    menuCaption?: React.ReactNode;
    revisionInfo?: CommitData;
}

export const DocumentMenu = ({docInfo, menuCaption, revisionInfo, ...restProps}: Props) => {
    const toggleFavoriteMutation = useToggleFavoriteMutation();
    const copyLink = useCopyLinkToThisPage();
    const {editingPermitted} = useUserEditingPermissions();

    const toggleFavorite = () => toggleFavoriteMutation.mutate(docInfo!);

    const handleOpenInEditMode = () => {
        browserNavigate(`/documents/edit/${docInfo.accession}`);
    };

    const revisionsInfoIllegalProps = {
        as: Link,
        to: `/${docInfo.accession}/revisions/${revisionInfo?.revision}`
    };

    return (
        <Menu {...restProps}>
            {docInfo && menuCaption ? (
                <MenuCaption>
                    <DocumentTypeLabel type={docInfo.type} variant="full" />
                    {menuCaption}
                </MenuCaption>
            ) : null}

            <MenuItem disabled={!revisionInfo} {...revisionsInfoIllegalProps}>
                Show revisions
            </MenuItem>

            {docInfo ? (
                <MenuItem onClick={toggleFavorite}>
                    {docInfo.userFavorite ? 'Remove from' : 'Add to'} Bookmarks
                </MenuItem>
            ) : null}

            {editingPermitted && (
                <MenuItem onClick={handleOpenInEditMode} disabled={isReadOnlyOntology(docInfo)}>
                    Open in edit mode
                </MenuItem>
            )}
            <Divider key="divider" />

            <MenuItem onClick={copyLink}>Copy link</MenuItem>
        </Menu>
    );
};
